<template>
  <div>
    <div class="lxm-contact-bottom-bar columns is-gapless is-mobile">
      <div class="column is-4 has-text-left">
        <a class="lxm-contact-bottom-bar__button button"
           :class="{ 'is-disabled': telDisabled }"
           @click="telClicked">
          <div class="lxm-contact-bottom-bar__button-icon lxm-contact-bottom-bar__button-icon--call"></div>
          打电话
        </a>
      </div>
      <div class="column is-4 has-text-centered">
        <a class="lxm-contact-bottom-bar__button button"
           :class="{ 'is-disabled': smsDisabled }"
           @click="smsClicked">
          <div class="lxm-contact-bottom-bar__button-icon lxm-contact-bottom-bar__button-icon--sms"></div>
          发信息
        </a>
      </div>
      <div class="column is-4 has-text-right">
        <a class="lxm-contact-bottom-bar__button button"
           :class="{ 'is-disabled': mapDisabled }"
           @click="mapClicked">
          <div class="lxm-contact-bottom-bar__button-icon lxm-contact-bottom-bar__button-icon--map"></div>
          看地图
        </a>
      </div>
    </div>
    <div class="lxm-contact-bottom-bar-placeholder"></div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-contact-bottom-bar-placeholder
    height: footer-bar-height
  .lxm-contact-bottom-bar
    position: fixed
    bottom: 0
    padding: 0 spacing * 2
    width: 100vw
    height: footer-bar-height
    background-color: brand-primary
    &.columns.is-gapless:not(:last-child)
      margin-bottom: 0
  .lxm-contact-bottom-bar__button
    margin-top: spacing
    &.button
      font-size: siz(12)
      color: brand-primary
      border: 0
      padding-left: siz(10)
      padding-right: siz(10)
      height: siz(27)
      .lxm-contact-bottom-bar__button-icon--call
        background-image: url(../../images/main/contact/bar-call.png)
        background-size: siz(15) siz(13)
      .lxm-contact-bottom-bar__button-icon--sms
        background-image: url(../../images/main/contact/bar-sms.png)
        background-size: siz(16) siz(13.5)
      .lxm-contact-bottom-bar__button-icon--map
        background-image: url(../../images/main/contact/bar-map.png)
        background-size: siz(11) siz(15)
      &.is-disabled
        opacity: 1
        color: grey-dark
        background-color: grey-white
        .lxm-contact-bottom-bar__button-icon--call
          background-image: url(../../images/main/contact/bar-call-disabled.png)
        .lxm-contact-bottom-bar__button-icon--sms
          background-image: url(../../images/main/contact/bar-sms-disabled.png)
        .lxm-contact-bottom-bar__button-icon--map
          background-image: url(../../images/main/contact/bar-map-disabled.png)
  .lxm-contact-bottom-bar__button-icon
    display: inline-block
    width: siz(16)
    height: siz(16)
    background-repeat: no-repeat
    background-position: center center
    margin-right: siz(8)
</style>

<script>
  export default {
    props: {
      phone: String,
      address: String
    },
    computed: {
      telDisabled () {
        return !this.phone
      },
      smsDisabled () {
        return !this.phone
      },
      mapDisabled () {
        return !this.address
      }
    },
    methods: {
      telClicked () {
        if (!this.telDisabled) {
          window.open(`tel:${this.phone}`)
        }
      },
      smsClicked () {
        if (!this.smsDisabled) {
          window.open(`sms:${this.phone}`)
        }
      },
      mapClicked () {
        if (!this.mapDisabled) {
          window.open(`http://m.amap.com/?k=${this.address}`)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmContactBottomBar.vue?68d259a5